import {
  getGradingCommentTemplatesField,
  getLearningCourseField,
} from "./modules/utils";

const IbPypCurriculumProgramPolicy = {
  IbPypCurriculumProgram: {
    fields: {
      gradingCommentTemplates: getGradingCommentTemplatesField(),
      learningCourse: getLearningCourseField(),
    },
  },
};

export default IbPypCurriculumProgramPolicy;
